<template>
  <ItemWrapper>
    <v-row>
      <v-col cols="12" lg="6">
        <AppCard :title="$t('Edit Ticket Queue')" :prev-route="prevRoute" :loading="pending.getEditTicketQueue">
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form autocomplete="off" @submit.prevent="handleSubmit(submitForm)">
              <v-container py-0>
                <v-row wrap>
                  <v-col cols="12">
                    <VTextFieldWithValidation
                      v-model="name"
                      rules="required|max:50"
                      :counter="50"
                      label="Name"
                      placeholder="Enter Name"
                    />
                  </v-col>

                  <v-col cols="12">
                    <VSelectWithValidation
                      v-model="user_id"
                      rules="required"
                      label="Moderator"
                      :items="usersArray"
                      menu-props="offset-y"
                      placeholder="Select Moderator"
                    />
                  </v-col>

                  <v-col cols="12">
                    <VAutocompleteWithValidation
                      v-model="users"
                      multiple
                      label="Users"
                      :items="usersArray"
                      menu-props="offset-y"
                      placeholder="Select Users"
                    />
                  </v-col>

                  <v-col cols="12" class="text-right">
                    <v-btn
                      type="submit"
                      class="mx-0 font-weight-light"
                      color="success"
                      :disabled="pending.editTicketQueue"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </ValidationObserver>
        </AppCard>
      </v-col>
    </v-row>
  </ItemWrapper>
</template>

<script>
import { computed, defineComponent, onUnmounted, ref } from '@vue/composition-api'
import { mapFields } from 'vuex-composition-map-fields'

import useDirectRedirectToItem from '@/composables/useDirectRedirectToItem'
import { parseObjectToArray } from '@/helpers'

import AppCard from '@/components/UI/AppCard.vue'
import ItemWrapper from '@/layouts/ItemWrapper.vue'
import VTextFieldWithValidation from '@/components/inputs/VTextFieldWithValidation.vue'
import VSelectWithValidation from '@/components/inputs/VSelectWithValidation.vue'
import VAutocompleteWithValidation from '@/components/inputs/VAutocompleteWithValidation.vue'

export default defineComponent({
  name: 'EditTicketQueue',
  components: {
    AppCard,
    ItemWrapper,
    VTextFieldWithValidation,
    VSelectWithValidation,
    VAutocompleteWithValidation,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // vm.prevRoute = from.fullPath === '/' ? vm.prevRoute : from.fullPath
    })
  },
  setup(props, { root: { $store, $router } }) {
    const { redirectDirect, setForceRedirect } = useDirectRedirectToItem()
    const prevRoute = ref('/TicketQueues')

    // store
    const pending = computed(_ => $store.state.ticketQueue.pending)
    const ticketQueuePresets = computed(_ => $store.state.ticketQueue.ticketQueuePresets)
    const errors = computed(_ => $store.state.ticketQueue.errors)
    const editTicketQueue = _ => $store.dispatch('ticketQueue/editTicketQueue')
    const getEditTicketQueue = _ => $store.dispatch('ticketQueue/getEditTicketQueue')
    const clearTicketQueue = _ => $store.dispatch('ticketQueue/clearTicketQueue')

    const usersArray = computed(_ => parseObjectToArray(ticketQueuePresets.value.users))

    getEditTicketQueue()

    const submitForm = _ => {
      if (pending.value.editTicketQueue) {
        return
      }
      if (redirectDirect.value) {
        setForceRedirect(true)
      }

      editTicketQueue().then(({ ticketQueue, errors }) => {
        if (errors) {
          setForceRedirect(false)
          return
        }

        if (redirectDirect.value) {
          $router.push({
            name: 'ticketQueues-item',
            params: { id: ticketQueue.id },
          })
        } else {
          $router.push({ path: prevRoute.value })
        }
      })
    }

    onUnmounted(_ => {
      clearTicketQueue()
    })

    return {
      prevRoute,
      pending,
      errors,
      usersArray,
      submitForm,
      ...mapFields('ticketQueue', [
        'ticketQueue.name',
        'ticketQueue.user_id',
        'ticketQueue.users',
      ]),
    }
  },
}) //
</script>
